(function () {
  // Engagement events are sent in every mode: they are the only thing that
  // lowers the risk score, so a visitor once flagged suspicious would
  // otherwise be stuck on the home offer. AdSense itself loads only when the
  // server chose ADSENSE for this page.
  var isAdsenseMode = !!window.__MON__ && window.__MON__.mode === 'ADSENSE';

  var sent = { scroll: false, interact: false, time8: false };

  function postEvent(eventName) {
    return fetch('/t/e', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: eventName })
    }).catch(function () { });
  }

  function onScroll() {
    if (sent.scroll) return;
    if (window.scrollY >= 200) {
      sent.scroll = true;
      postEvent('scroll');
      window.removeEventListener('scroll', onScroll);
    }
  }

  function onInteract() {
    if (sent.interact) return;
    sent.interact = true;
    postEvent('interact');
    window.removeEventListener('pointerdown', onInteract);
    window.removeEventListener('keydown', onInteract);
    window.removeEventListener('touchstart', onInteract);
  }

  function gtagRisk(level) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'traffic_risk', { risk_level: level });
    }
  }

  function pushAds() {
    // Lazy slots are pushed by ads.html. The separate pushed marker remains
    // stable when AdSense changes data-ad-status to filled/unfilled, and also
    // prevents script.onload from pushing a slot already queued by the
    // IntersectionObserver while the AdSense script was still loading.
    var adBlocks = document.querySelectorAll(
      'ins.adsbygoogle:not([data-ad-status="init"]):not([data-ad-pushed])'
    );

    if (!adBlocks.length) return;

    for (var i = 0; i < adBlocks.length; i++) {
      try {
        adBlocks[i].setAttribute('data-ad-pushed', 'true');
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        adBlocks[i].removeAttribute('data-ad-pushed');
      }
    }
  }

  function loadAdsense(clientId) {
    if (!clientId || window.__riskAdsenseLoaded) {
      pushAds();
      return;
    }

    window.__riskAdsenseLoaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=' + encodeURIComponent(clientId);
    script.crossOrigin = 'anonymous';
    script.onload = pushAds;
    document.head.appendChild(script);
  }

  // AdSense starts loading immediately rather than after a /t/risk round
  // trip: the server already picked ADSENSE only for visitors it scored as
  // human, and every extra hop delays the above-the-fold slot past the
  // point where it can count as a viewable impression.
  if (isAdsenseMode) {
    var config = document.querySelector('[data-adsense-client]');
    if (config) {
      loadAdsense(config.getAttribute('data-adsense-client'));
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pointerdown', onInteract, { passive: true });
  window.addEventListener('keydown', onInteract);
  window.addEventListener('touchstart', onInteract, { passive: true });

  setTimeout(function () {
    if (sent.time8) return;
    sent.time8 = true;
    postEvent('time8');
  }, 8000);

  fetch('/t/risk')
    .then(function (response) { return response.json(); })
    .then(function (data) {
      gtagRisk(data.riskLevel);
    })
    .catch(function () { });
})();
